import { Box } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import AnimatedTypography from '../../core/AnimatedTypography';
import ReviewForm from './ReviewForm';
import ReviewList from './ReviewList';
import { useTranslation } from 'react-i18next';

interface ReviewProps {
}

const Review: React.FC<ReviewProps> = ({ }) => {

    const { t } = useTranslation();

    const [visible, setVisible] = useState(false);
    const triggerRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setVisible(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (triggerRef.current) {
            observer.observe(triggerRef.current);
        }

        return () => observer.disconnect();
    }, []);
    return (
        <Box ref={triggerRef} mt={1}>
            <AnimatedTypography variant='h3' mb={2} color={"text2.primary"} fontWeight={600}>{t("review.title")}</AnimatedTypography>
            {visible && (
                <ReviewList />
            )}
            <ReviewForm />
        </Box>
    )
}

export default Review;